import { useEffect } from "react";
import { useLocation } from "react-router-dom";

// On route change: if the URL has a hash (e.g. /#fleet), smooth-scroll to that
// section (retrying while lazy sections/hydration finish); otherwise scroll to top.
export default function ScrollToTop() {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (hash) {
      const id = decodeURIComponent(hash.replace(/^#/, ""));
      let tries = 0;
      const tryScroll = () => {
        const el = document.getElementById(id);
        if (el) {
          el.scrollIntoView({ behavior: "smooth", block: "start" });
        } else if (tries++ < 25) {
          setTimeout(tryScroll, 120);
        }
      };
      setTimeout(tryScroll, 60);
      return;
    }
    window.scrollTo({ top: 0, left: 0, behavior: "instant" });
  }, [pathname, hash]);
  return null;
}
